import React, { useState } from "react";

import Input from "Components/Form/Input";
import Select from "Components/Form/Select";
import { Pagination } from "Components/Pagination";
import PageHeader from "Components/Pages/Header";
import Breadcrumb from "Components/Shared/Breadcrumb";
import ProductListIcon from "Assets/Images/list-products.svg";
import { Button } from "Components/Button";
import { useQuery } from "react-query";
import { Loader } from "Components/Loader";
import { getPartnersAPI } from "Requests/Partners";
import * as S from "./styles";
import { PartnersList } from "./components/PartnersList";

const statusOptions = [
  { id: 1, name: "Ativo" },
  { id: 0, name: "Inativo" },
];

const Partners = () => {
  const [page, setPage] = useState(1);
  const [filterForm, setFilterForm] = useState({ status: "", search: "" });
  const [filtersApplied, setFiltersApplied] = useState({
    status: "",
    search: "",
  });

  const { data, isLoading } = useQuery({
    queryFn: () => getPartnersAPI({ page, ...filtersApplied }),
    queryKey: ["partners-list", page, filtersApplied],
    refetchOnWindowFocus: false,
  });

  function handleChange({ target: { value, name } }) {
    if (name === "search") {
      setFilterForm((prev) => ({
        ...prev,
        search: value,
      }));
      return;
    }

    setFilterForm((prev) => ({
      ...prev,
      status: value,
    }));
  }

  function handlePagination(e) {
    if (page === e.currentPage) return;
    setPage(e.currentPage);
  }

  function handleSubmit(event) {
    event.preventDefault();

    if (filterForm.status === "" && filterForm.search === "") return;

    setFiltersApplied({
      ...filterForm,
    });
  }

  const clearFilters = () => {
    setFiltersApplied({
      status: "",
      search: "",
    });
    setFilterForm({ status: "", search: "" });
  };

  return (
    <S.PageContainer className="entry-app-content">
      <div className="content-holder">
        <div>
          <div className="wrapper-header-content">
            <PageHeader title="Parceiros" icon={ProductListIcon}>
              <Breadcrumb
                list={[
                  {
                    path: "/parceiros",
                    label: "Parceiros",
                    current: true,
                  },
                ]}
              />
            </PageHeader>

            <S.FormContainer onSubmit={handleSubmit} className="form-heading">
              <div className="inputs-container">
                <div className="search-input">
                  <Input
                    id="search"
                    type="search"
                    placeholder="Buscar por nome do parceiro"
                    value={filterForm.search}
                    onChange={handleChange}
                  />
                </div>
                <div className="search-input">
                  <Select
                    id="status"
                    type="text"
                    value={filterForm.status}
                    options={statusOptions}
                    placeholder="Status"
                    onChange={handleChange}
                  />
                </div>
                <div className="buttons-container">
                  <Button type="submit">Filtrar</Button>
                  <Button onClick={clearFilters}>Limpar busca</Button>
                </div>
              </div>
            </S.FormContainer>
          </div>
        </div>

        <div className="page-content page-content-list">
          {isLoading ? (
            <div className="loader">
              <Loader />
            </div>
          ) : (
            <PartnersList partners={data.data} />
          )}
        </div>
        <div className="pagination-wrapper">
          {data?.last_page > 1 && (
            <Pagination
              totalRecords={data.last_page}
              currentPageSelected={data.current_page}
              pageLimit={1}
              pageNeighbours={1}
              onPageChanged={(e) => handlePagination(e)}
            />
          )}
        </div>
      </div>
    </S.PageContainer>
  );
};

export default Partners;
